export const paymentSources = [
	{ orderType: 'DELIVERY', paymentSource: 'CASH_REGISTER_DELIVERY' },
	{ orderType: 'PICKUP', paymentSource: 'CASH_REGISTER_PICK_UP' },
	{ orderType: 'COUNTER', paymentSource: 'CASH_REGISTER_COUNTER' },
	{ orderType: 'RESTAURANT', paymentSource: 'RESTAURANT' },
]

export const cardReadFailureErrors = ['CARD_TRANSACTION_DECLINED', 'CARD_READ_TIMED_OUT']
